import types, { State, Actions } from "./types";

export default function reducer(state: State, action: Actions): State {
  switch (action.type) {
    case types.SIDEBAR_CLICK:
      return {
        ...state,
        sidebarState: !state.sidebarState,
      };
    case types.SET_USER_INFO:
      return {
        ...state,
        userId: action.payload.userId,
        userEmail: action.payload.userEmail,
        userName: action.payload.userName,
        userNickname: action.payload.userNickname,
        userType: action.payload.userType,
        userStudentNumber: action.payload.userStudentNumber,
      };
    case types.SET_READ_USER:
      return {
        ...state,
        readUser: action.payload.readUser,
      }
    case types.SET_LANGUAGE:
        return {
          ...state,
          language: action.payload.language
        }
    default:
      throw new Error("Unexpected Action Type");
  }
}
